/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Model_Id_DescriptionInputs */



/**
* | output |
* | --- |
* | "Unique identifier for API calls. Use lowercase with hyphens." |
*
* @param {Private_Models_Form_Model_Id_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_model_id_description = /** @type {((inputs?: Private_Models_Form_Model_Id_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Model_Id_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eindeutige Kennung für API-Aufrufe. Kleinbuchstaben mit Bindestrichen verwenden.")
	return /** @type {LocalizedString} */ ("Unique identifier for API calls. Use lowercase with hyphens.")
});